import { Card } from "@/app/admin/_common/ui/card";
import { Skeleton } from "@/app/admin/_common/ui/skeleton";

export default function LinkDetailSkeleton() {
  return (
    <div className="flex flex-col gap-12">
      <div className="grid grid-cols-2 gap-2.5 sm:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <Card key={i} className="rounded-md p-3.5 shadow-none">
            <Skeleton className="mb-2 h-3 w-20" />
            <Skeleton className="mb-2 h-5 w-16" />
            <Skeleton className="h-3 w-12" />
          </Card>
        ))}
      </div>

      <div className="flex flex-col gap-6">
        <div className="grid gap-1">
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-3 w-80" />
        </div>
        <div className="grid gap-4 sm:grid-cols-2">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="grid gap-3">
              <Skeleton className="h-3.5 w-20" />
              <Skeleton className="h-[30px] w-full rounded-md" />
            </div>
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-6">
        <Skeleton className="h-3.5 w-28" />
        <div className="grid gap-4 sm:grid-cols-2">
          <div className="grid content-start gap-4">
            <div className="grid gap-3">
              <Skeleton className="h-3.5 w-20" />
              <Skeleton className="h-[30px] w-full rounded-md" />
            </div>
            <div className="grid gap-3">
              <Skeleton className="h-3.5 w-28" />
              <Skeleton className="h-[72px] w-full rounded-md" />
            </div>
            <div className="grid gap-3">
              <Skeleton className="h-3.5 w-24" />
              <Skeleton className="h-[38px] w-full rounded-md" />
            </div>
          </div>
          <div className="grid content-start gap-2">
            <Skeleton className="h-3.5 w-16" />
            <Skeleton className="aspect-[1.91/1] w-full rounded-md" />
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-6">
        <div className="grid gap-1">
          <Skeleton className="h-3.5 w-16" />
          <Skeleton className="h-3 w-72" />
        </div>
        <div className="flex min-h-[420px] flex-1 flex-col overflow-hidden border-t border-border bg-card md:rounded-md md:border md:border-border">
          <div className="flex h-8 items-center gap-4 border-b border-border/50 bg-muted/50 px-4">
            <Skeleton className="h-3 w-8" />
            <Skeleton className="h-3 w-32" />
            <Skeleton className="h-3 w-10" />
            <Skeleton className="h-3 w-12" />
            <Skeleton className="h-3 w-20" />
            <Skeleton className="h-3 w-28" />
            <Skeleton className="h-3 w-24" />
          </div>
          {Array.from({ length: 10 }).map((_, i) => (
            <div
              key={i}
              className="flex h-[42px] items-center gap-4 border-b border-border/50 px-4 last:border-0"
            >
              <Skeleton className="h-3 w-8" />
              <Skeleton className="h-3 w-32" />
              <Skeleton className="h-3 w-10" />
              <Skeleton className="h-3 w-12" />
              <Skeleton className="h-3 w-20" />
              <Skeleton className="h-3 w-28" />
              <Skeleton className="h-3 w-24" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
